import Vue from 'vue'
import VueRouter from 'vue-router'
// Inventario, marcas/categorías y ventas eliminados: imports removidos
import MiembrosComponent from '@/components/Clientes/MiembrosComponent'
import UsuariosComponent from '@/components/Usuarios/UsuariosComponent'
import AgregarUsuario from '@/components/Usuarios/AgregarUsuario'
import EditarUsuario from '@/components/Usuarios/EditarUsuario'
import RolesComponent from '@/components/Usuarios/RolesList'
import RolesForm from '@/components/Usuarios/RolesForm'
import ConfiguracionComponent from '@/components/Configuracion/ConfiguracionComponent'
import PerfilComponent from '@/components/Usuarios/PerfilComponent'
import CambiarPassword from '@/components/Usuarios/CambiarPassword'
import InicioComponent from '@/components/InicioComponent'
import GruposComponent from '@/components/Extras/Multisucursal'
import SeleccionarGrupoComponent from '@/components/Extras/SeleccionarGrupo'
import ControlAsistencia from '@/components/Extras/ControlAsistencia'
import EstadisticaAsistencias from '@/components/Extras/EstadisticaAsistencias'
import CensoComponent from '@/components/Censo/CensoComponent'
import AyudanteSesion from '@/Servicios/AyudanteSesion'

Vue.use(VueRouter)

// Evita "NavigationDuplicated" cuando se navega a la ruta actual (ej. redirección del guard a '/')
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

const routes = [
  {
    path: '/',
    name: 'InicioComponent',
    component: InicioComponent
  },
  // Rutas de inventario, marcas/categorías y ventas eliminadas
  
  {
    path: '/miembros',
    name: 'MiembrosComponent',
    component: MiembrosComponent
  },
  {
    path: '/usuarios',
    name: 'UsuariosComponent',
    component: UsuariosComponent,
    meta: { requiresSuper: true }
  },  
  {
    path: '/roles',
    name: 'RolesList',
    component: RolesComponent,
    meta: { requiresSuper: true }
  },
  {
    path: '/roles/crear',
    name: 'RolesCreate',
    component: RolesForm,
    meta: { requiresSuper: true }
  },
  {
    path: '/roles/editar/:id',
    name: 'RolesEdit',
    component: RolesForm,
    meta: { requiresSuper: true }
  },
  {
    path: '/agregar-usuario',
    name: 'AgregarUsuario',
    component: AgregarUsuario,
    meta: { requiresSuper: true }
  },
  {
    path: '/editar-usuario/:id',
    name: 'EditarUsuario',
    component: EditarUsuario,
    meta: { requiresSuper: true }
  },  
  {
    path: '/configurar',
    name: 'ConfiguracionComponent',
    component: ConfiguracionComponent,
    meta: { requiresSuper: true }
  },
  {
    path: '/multisucursal',
    name: 'Grupos',
    component: GruposComponent,
    meta: { requiresSuper: true }
  },
  {
    path: '/seleccionar-grupo',
    name: 'SeleccionarGrupo',
    component: SeleccionarGrupoComponent,
    meta: { requiresSuper: true }
  },
  {
    path: '/censo',
    name: 'CensoComponent',
    component: CensoComponent,
    meta: { requiresSuper: true }
  },
  {
    path: '/control-asistencia',
    name: 'ControlAsistencia',
    component: ControlAsistencia
  },
  {
    path: '/estadistica-asistencias',
    name: 'EstadisticaAsistencias',
    component: EstadisticaAsistencias
  },
  {
    path: '/perfil',
    name: 'PerfilComponent',
    component: PerfilComponent
  },  
  {
    path: '/cambiar-password',
    name: 'CambiarPassword',
    component: CambiarPassword
  },

]

const router = new VueRouter({
  routes
})

// Protege rutas que sólo deben ver los usuarios SUPER
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta && record.meta.requiresSuper)) {
    if (!AyudanteSesion.esSuper()) return next('/')
  }
  next()
})

export default router
